module.exports = __webpack_public_path__ + "img/spaceGame1.f8ec4aef.png";